import React from 'react';
import { Link } from 'react-router-dom';
import { EmptyPage } from '../../../assets/images';

type AppProps = {
  title?: string;
  text?: string;
  image?: any;
  showAddButton?: boolean;
  imageWidth?: string;
  buttonTitle?: string;
  link?: string;
  linkState?: any;
  client_code?: number;
  company_name?: string;
  onButtonClick?: () => void;
  showLinkButton?: boolean;
}

const EmptyListPage = ({
  title,
  text,
  image,
  imageWidth,
  showAddButton,
  showLinkButton,
  buttonTitle,
  link,
  client_code,
  onButtonClick,
  company_name
}: AppProps) => {

  const finalLink = {
    pathname: link,
    state: { company_name, client_code }
  }

  return (
    <div>
      <h1 className="text-center">
        {title}
      </h1>
      <div className="text-center">
        <span className="sub-text">{text}</span>
        {showAddButton && <div className='mt-3'>
          <button
            onClick={onButtonClick}
            className="btn btn-primary">
            {buttonTitle}
          </button>
        </div>}
        {showLinkButton && <div className="mt-3">
          <Link className="btn btn-primary" to={finalLink}>
            {buttonTitle}
          </Link>
        </div>}
        <div className="mt-5">
          <img src={image ?? EmptyPage} style={{ width: imageWidth }} />
        </div>
      </div>
    </div>
  )
};

export default EmptyListPage;